import "./App.css";
import { AuthenticatedUser } from "./routers/AuthenticatedRoutes";
import { UnAuthenticatedUser } from "./routers/UnAuthenticatedRoutes";
const token = localStorage.getItem("auction-client");

const App = () => {
  return token ? <AuthenticatedUser /> : <UnAuthenticatedUser />;
};

export default App;
